var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50065 0.583313C12.8729 0.583313 16.4173 4.12773 16.4173 8.49998C16.4173 12.8722 12.8729 16.4166 8.50065 16.4166C4.1284 16.4166 0.583984 12.8722 0.583984 8.49998C0.583984 4.12773 4.1284 0.583313 8.50065 0.583313ZM11.1075 5.56519L6.91732 9.75539L5.89378 8.73185C5.58461 8.42269 5.08336 8.42269 4.77419 8.73185C4.46503 9.04102 4.46503 9.54227 4.77419 9.85144L6.35752 11.4348C6.66669 11.7439 7.16794 11.7439 7.47711 11.4348L12.2271 6.68477C12.5363 6.37561 12.5363 5.87435 12.2271 5.56519C11.9179 5.25602 11.4167 5.25602 11.1075 5.56519Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.3b680ec6.svg";
export { ForwardRef as ReactComponent };